import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {Card, Col, Container, Input, Label, Modal, ModalBody, Row} from 'reactstrap';
import "./Custom.css";
import {useDispatch} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {toast} from 'react-toastify';

const anableFunctions = [
    "t-departments1",
    "t-departments2",
    "t-departments3",
    "t-departments4",
    "t-departments5",
    "t-departments6",
    "t-departments7",
    "t-departments8",
    "t-departments9"
];

const pricesObj = {
    50: {price: 18000, default: 18000, locat: false, tasks: false, job: false},
    100: {price: 17500, default: 17500, locat: false, tasks: false, job: false},
    150: {price: 17000, default: 17000, locat: false, tasks: false, job: false},
    200: {price: 16500, default: 16500, locat: false, tasks: false, job: false},
    250: {price: 16000, default: 16000, locat: false, tasks: false, job: false},
    300: {price: 15500, default: 15500, locat: false, tasks: false, job: false},
    350: {price: 15000, default: 15000, locat: false, tasks: false, job: false},
    400: {price: 14500, default: 14500, locat: false, tasks: false, job: false},
    450: {price: 14000, default: 14000, locat: false, tasks: false, job: false},
    500: {price: 13500, default: 13500, locat: false, tasks: false, job: false},
};
const Prices = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const [plan, setPlan] = useState(true);
    const toggle = () => setPlan(!plan);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [prices, setPrices] = useState(pricesObj);
    const [type, setType] = useState(50);
    const [numberOfEmployees, setNumberOfEmployees] = useState(50);
    const toggleModalPrices = () => {
        setIsModalOpen(state => !state);
        setPrices(pricesObj);
    };
    useEffect(() => {
        setPrices(state => {
            let newState = {...state};
            Object.keys(state).forEach(val => {
                newState[val]['price'] = newState[val]['default'];
            });
            return newState;
        });
    }, [isModalOpen]);

    const handlerClick = (num) => {
        toggleModalPrices();
        setType(num);

        setNumberOfEmployees(num);
    }

    const handlerChange = (e, id) => {
        switch (id) {
            case 1:
                setPrices(state => {
                    let newState = {...state};
                    if (e.target.checked)
                        newState[type]['price'] += newState[type]['default'] * 0.2;
                    else
                        newState[type]['price'] -= newState[type]['default'] * 0.2;
                    newState[type]['locat'] = !newState[type]['locat'];
                    return newState;
                });
                break;
            case 2:
                setPrices(state => {
                    let newState = {...state};
                    if (e.target.checked)
                        newState[type]['price'] += newState[type]['default'] * 0.2;
                    else
                        newState[type]['price'] -= newState[type]['default'] * 0.2;
                    newState[type]['tasks'] = !newState[type]['tasks'];
                    return newState;
                });
                break;
            case 3:
                setPrices(state => {
                    let newState = {...state};
                    if (e.target.checked)
                        newState[type]['price'] += newState[type]['default'] * 0.2;
                    else
                        newState[type]['price'] -= newState[type]['default'] * 0.2;
                    newState[type]['job'] = !newState[type]['job'];
                    return newState;
                });
                break;
            default:
                break;
        }
    }

    const demoRequest = async (e) => {
        e.preventDefault();

        // dispatch(changePrice({...prices[type], type: type}));
        toggleModalPrices();

        if (localStorage.getItem('HR_USER_ID')) {
            let response = await fetch('https://online.hrplus.uz/send-request-use-tariff', {
                method: "POST",
                headers: {
                    "Content-type": "application/json",
                    "login": 'HRplus+',
                    "password": 'Ctc0oTYayc77z'
                },
                body: JSON.stringify({
                    user_id: +localStorage.getItem('HR_USER_ID'),
                    price: {...prices[type], type: type}
                })
            })
                .then(resp => resp.json())
                .catch(err => {
                    console.log(err);
                })

            if (response.status)
                toast.success(t("t-request-accepted"));
            else
                toast.error(t("t-server-error"));

        }
    }

    return (
        <React.Fragment>
            <section className="section bg-light" id="prices">
                <div className="bg-overlay bg-overlay-pattern"></div>
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={8}>
                            <div className="text-center mb-4">
                                <h3 className="mb-2 fw-semibold">{t('t-rates')}</h3>
                                <p className="text-muted mb-2">
                                    {t('t-select-rate')}
                                </p>
                                {/* 
                                <div className="d-flex justify-content-center align-items-center">
                                    <div>
                                        <h5 className="fs-14 mb-0">Oylik</h5>
                                    </div>
                                    <div className="form-check form-switch fs-20 ms-3 " onClick={toggle} >
                                        <input className="form-check-input" type="checkbox" id="plan-switch" />
                                        <label className="form-check-label" htmlFor="plan-switch"></label>
                                    </div>
                                    <div>
                                        <h5 className="fs-14 mb-0">Yillik <span className="badge badge-soft-success">15% chegirma</span></h5>
                                    </div>
                                </div> */}
                            </div>
                        </Col>
                    </Row>

                    {/* <Row className="gy-4">
                        <Col lg={4}>
                            <Card className="plan-box mb-0">
                                <CardBody className="p-4 m-2">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h5 className="mb-1 fw-semibold">Basic Plan</h5>
                                            <p className="text-muted mb-0">For Startup</p>
                                        </div>
                                        <div className="avatar-sm">
                                            <div className="avatar-title bg-light rounded-circle text-primary">
                                                <i className="ri-book-mark-line fs-20"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="py-4 text-center">
                                        {plan ? <h1 className="month"><sup><small>$</small></sup><span className="ff-secondary fw-bold">19</span> <span
                                            className="fs-13 text-muted">/Month</span></h1> :
                                            <h1 className="annual"><sup><small>$</small></sup><span className="ff-secondary fw-bold">171</span> <span
                                                className="fs-13 text-muted">/Year</span></h1>}
                                    </div>

                                    <div>
                                        <ul className="list-unstyled text-muted vstack gap-3 ff-secondary">
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        Upto <b>3</b> Projects
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        Upto <b>299</b> Customers
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        Scalable Bandwidth
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <b>5</b> FTP Login
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-danger me-1">
                                                        <i className="ri-close-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <b>24/7</b> Support
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-danger me-1">
                                                        <i className="ri-close-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <b>Unlimited</b> Storage
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-danger me-1">
                                                        <i className="ri-close-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        Domain
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                        <div className="mt-4">
                                            <Link to="#" className="btn btn-soft-success w-100">Get
                                                Started</Link>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col lg={4}>
                            <Card className="plan-box mb-0 ribbon-box right">
                                <CardBody className="p-4 m-2">
                                    <div className="ribbon-two ribbon-two-danger"><span>Popular</span></div>
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h5 className="mb-1 fw-semibold">Pro Business</h5>
                                            <p className="text-muted mb-0">Professional plans</p>
                                        </div>
                                        <div className="avatar-sm">
                                            <div className="avatar-title bg-light rounded-circle text-primary">
                                                <i className="ri-medal-fill fs-20"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="py-4 text-center">
                                        {plan ? <h1 className="month"><sup><small>$</small></sup><span className="ff-secondary fw-bold">29</span> <span
                                            className="fs-13 text-muted">/Month</span></h1> :
                                            <h1 className="annual"><sup><small>$</small></sup><span className="ff-secondary fw-bold">261</span> <span
                                                className="fs-13 text-muted">/Year</span></h1>}
                                    </div>

                                    <div>
                                        <ul className="list-unstyled text-muted vstack gap-3 ff-secondary">
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        Upto <b>15</b> Projects
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <b>Unlimited</b> Customers
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        Scalable Bandwidth
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <b>12</b> FTP Login
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <b>24/7</b> Support
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-danger me-1">
                                                        <i className="ri-close-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <b>Unlimited</b> Storage
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-danger me-1">
                                                        <i className="ri-close-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        Domain
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                        <div className="mt-4">
                                            <Link to="#" className="btn btn-soft-success w-100">Get
                                                Started</Link>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>

                        <Col lg={4}>
                            <Card className="plan-box mb-0">
                                <CardBody className="p-4 m-2">
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h5 className="mb-1 fw-semibold">Platinum Plan</h5>
                                            <p className="text-muted mb-0">Enterprise Businesses</p>
                                        </div>
                                        <div className="avatar-sm">
                                            <div className="avatar-title bg-light rounded-circle text-primary">
                                                <i className="ri-stack-fill fs-20"></i>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="py-4 text-center">
                                        {plan ? <h1 className="month"><sup><small>$</small></sup><span className="ff-secondary fw-bold">39</span> <span
                                            className="fs-13 text-muted">/Month</span></h1> :
                                            <h1 className="annual"><sup><small>$</small></sup><span className="ff-secondary fw-bold">351</span> <span
                                                className="fs-13 text-muted">/Year</span></h1>}
                                    </div>

                                    <div>
                                        <ul className="list-unstyled text-muted vstack gap-3 ff-secondary">
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <b>Unlimited</b> Projects
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <b>Unlimited</b> Customers
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        Scalable Bandwidth
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <b>Unlimited</b> FTP Login
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <b>24/7</b> Support
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        <b>Unlimited</b> Storage
                                                    </div>
                                                </div>
                                            </li>
                                            <li>
                                                <div className="d-flex">
                                                    <div className="flex-shrink-0 text-success me-1">
                                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                                    </div>
                                                    <div className="flex-grow-1">
                                                        Domain
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                        <div className="mt-4">
                                            <Link to="#" className="btn btn-soft-success w-100">Get
                                                Started</Link>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row> */}
                    <div className='d-flex gap-2 gap-md-3 gap-xl-4 flex-wrap justify-content-between'>
                        {Object.keys(pricesObj).map((key, index) => <Card
                            key={index}
                            className="mb-0 cursor-pointer rounded-4 box-shadow"
                            style={{padding: 30, paddingBottom: 20}}
                            onClick={() => {
                                handlerClick(+key)
                            }}
                        >
                            <div className={
                                "rounded-circle d-flex justify-content-center align-items-center bg-success-gradient"
                            }
                                 style={{width: 130, height: 130}}>
                                <p className='text-white mb-0 font-family'>
                                    <span className='fw-semibold' style={{
                                        fontSize: 45,
                                        lineHeight: 1
                                    }}>{Object.keys(pricesObj).length - 1 === index ? '450+' : key}</span> <br/>
                                    <span className='fw-bold fs-15'>{t('t-employees')}</span>
                                </p>
                            </div>
                            <div className='text-center fw-medium fs-17 mt-2 mb-0'>
                                {t('t-calculate')}
                            </div>
                        </Card>)}
                    </div>
                </Container>
            </section>
            <Modal
                isOpen={isModalOpen}
                toggle={toggleModalPrices}
                centered
            >
                <div className="modal-header p-3 bg-primary">
                    <h5 className=" text-white mb-0 textx-center">
                        {type > 450 ? t("t-emps-not-over").replace('{number}', 450) : t("t-emps-to").replace('{number}', type)}
                    </h5>
                    <span className="cursor-pointer" onClick={toggleModalPrices}>
                        <i className="ri-close-line fs-22 text-white"></i>
                    </span>
                </div>
                <ModalBody>
                    <div>
                        <ul className="list-unstyled vstack gap-2">
                            {anableFunctions.map((val, index) => <li key={index}>
                                <div className="d-flex">
                                    <div className="flex-shrink-0 text-success me-2">
                                        <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>
                                    </div>
                                    <div className="flex-grow-1">
                                        {t(val)}
                                    </div>
                                </div>
                            </li>)}
                        </ul>
                        <div>
                            <div className="form-check form-check-outline form-check-success mb-2 mb-xxl-3">
                                <Input className="form-check-input" type="checkbox" id="liveLocation" onChange={(e) => {
                                    handlerChange(e, 1);
                                }}/>
                                <Label className="form-check-label fw-normal" for="liveLocation">
                                    {t('t-extra-departments1')}
                                </Label>
                            </div>
                            <div className="form-check form-check-outline form-check-success mb-2 mb-xxl-3">
                                <Input className="form-check-input" type="checkbox" id="tasks" onChange={(e) => {
                                    handlerChange(e, 2);
                                }}/>
                                <Label className="form-check-label fw-normal" for="tasks">
                                    {t('t-extra-departments2')}
                                </Label>
                            </div>
                            <div className="form-check form-check-outline form-check-success mb-3">
                                <Input className="form-check-input" type="checkbox" id="job" onChange={(e) => {
                                    handlerChange(e, 3);
                                }}/>
                                <Label className="form-check-label fw-normal" for="job">
                                    {t('t-extra-departments3')}
                                </Label>
                            </div>
                        </div>
                        <div className='border-top pt-3 border-primary'>
                            <p className='mb-2'>
                                <span className='fw-semibold'>{t("t-for-one-emp")}:</span>
                                <span
                                    className='fw-medium ms-3'>{Number(prices[type]['price']).toLocaleString('en-us')} {t('t-soum')}</span>
                            </p>
                            <p>
                                <span className='fw-semibold'>
                                    {t("t-for-number-emp").split('{number}')[0]}
                                    {
                                        Number(type) > 450 ?
                                            <select
                                                className='form-select form-select-sm d-inline mx-1 pe-0'
                                                style={{width: 70}}
                                                onChange={(e) => {
                                                    setNumberOfEmployees(+e.target.value);
                                                }}
                                            >
                                                <option value={500}>500</option>
                                                <option value={600}>600</option>
                                                <option value={700}>700</option>
                                                <option value={800}>800</option>
                                                <option value={900}>900</option>
                                                <option value={1000}>1000</option>
                                            </select> : type
                                    }
                                    {t("t-for-number-emp").split('{number}')[1]}:
                                </span>
                                <span
                                    className='ms-3 fw-medium'>{Number(prices[type]['price'] * numberOfEmployees).toLocaleString('en-us')} {t('t-soum')}</span>
                            </p>
                        </div>
                        <div className="mt-4">
                            <Link to="#" className="btn btn-success w-100 fw-medium" onClick={demoRequest}>
                                {t('t-user-tariff')}
                            </Link>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </React.Fragment>
    );
};

export default Prices;